module.exports = __webpack_public_path__ + "03_short_brown.0cbc0599.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/03_short_brown.png
// module id = yC8r
// module chunks = 0